module.exports = __webpack_public_path__ + "img/recharge_complete.1433b594.png";